import { z } from 'zod'

import { BadgeColorKeys } from '@/components/ui/badge'

export const SurveyStatusEnum = z.enum(['Completed', 'Ongoing', 'On hold', 'Scheduled'])

export type SurveyStatus = z.infer<typeof SurveyStatusEnum>

export const SURVEY_STATUS_COLOR_MAP: Record<SurveyStatus, BadgeColorKeys> = {
  [SurveyStatusEnum.enum.Completed]: 'blue',
  [SurveyStatusEnum.enum['On hold']]: 'orange',
  [SurveyStatusEnum.enum.Ongoing]: 'green',
  [SurveyStatusEnum.enum.Scheduled]: 'purple',
}

export const getSurveyStatusColor = (status: SurveyStatus): BadgeColorKeys =>
  SURVEY_STATUS_COLOR_MAP[status]

export const SurveyCommunicationTypeEnum = z.enum(['email', 'in-app', 'sms'])

export type SurveyCommunicationType = z.infer<typeof SurveyCommunicationTypeEnum>

export const SurveyResponderStatusEnum = z.enum(['sent', 'delivered', 'opened', 'replied'])

export type SurveyResponderStatus = z.infer<typeof SurveyResponderStatusEnum>

export const SurveyTypeEnum = z.enum(['NPS', 'Single choice', 'Multiple choice'])

export type SurveyType = z.infer<typeof SurveyTypeEnum>

export const SurveyTriggerTimeEnum = z.enum(['before', 'after'])

export type SurveyTriggerTime = z.infer<typeof SurveyTriggerTimeEnum>

export const SurveyTriggerTypeEnum = z.enum([
  'moveIn',
  'moveOut',
  'leaseStart',
  'leaseEnd',
  'workOrder',
  'reservation',
])

export type SurveyTriggerType = z.infer<typeof SurveyTriggerTypeEnum>

export interface SurveyTemplateStatus {
  id: number
  templateName: string
  active: boolean
}

export interface SurveyQuestionResponse {
  option: string
  count: number
}

export interface SurveyQuestion {
  id: number
  order: number
  title: string
  answerOptions?: string[]
  responses?: SurveyQuestionResponse[]
}

export interface SurveyRecipients {
  groups?: unknown[]
  singleUnits?: unknown[]
  units?: unknown[]
  clientTags?: unknown[]
}

export interface SurveyDetails {
  id: number
  buildingId: number
  name: string
  type: SurveyType
  subtype?: string
  status: SurveyStatus
  communicationType: SurveyCommunicationType
  questions: SurveyQuestion[]
  recipients: SurveyRecipients
  startDate?: number
  startTime?: number
  endDate?: number
  visibilityPerDay: number
  visibilityDays: number
  isOneTime?: boolean
  responseTrigger?: boolean
  responseTriggerCondition?: string
  socialLinkService?: string
  reviewVia?: string
  startTriggerType?: string
  startTriggerTime?: string
  startTriggerDays?: number
  enablePushNotifications?: boolean
  isEventSurvey?: boolean
  eventId?: number
  templateName?: string
  includeInAnalytics?: boolean
  createdByEmail?: string
  targetCount?: number
}
